import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { leadSourceLabel } from '@avantstay/backoffice-core'

export const getChannelLabel = (channel: string) => {
  return leadSourceLabel[channel] ?? channel.replace(/_/g, ' ')
}

interface StaySnoozeLike {
  expirationAt: IDate
  active: boolean
  createdAt: IDate
  author: { name: string }
}

export interface StaySnooze {
  expirationAt: string
  active: boolean
  createdAt: string
  authorName: string
}

export const toStaySnooze = (snooze?: StaySnoozeLike | null): StaySnooze | undefined => {
  if (!snooze) return undefined

  return {
    expirationAt: String(snooze.expirationAt),
    active: snooze.active,
    createdAt: String(snooze.createdAt),
    authorName: snooze.author.name,
  }
}
